<template>
    <div class="Background">
        <div style="display: flex; justify-content: space-between;">
            <!-- <h2 class="Title">
            라이브 관리 (WebRTC)
            </h2> -->
            <div class="link_location">
                <h2 class="Title">
                    {{ $store.getters.t('라이브') }}
                    <v-icon class="mdi mdi-chevron-right" />
                    <span style="color: rgb(29, 120, 211); font-weight: bold;">{{ $store.getters.t('WebRTC 라이브') }}</span>
                    </h2>
            </div>

            <!-- <div class="link_location">
                라이브 <v-icon small class="mdi mdi-chevron-right" />
                <a href="/webrtc/stream_create">라이브 관리</a>
            </div> -->
        </div>

        <WebRtcLivestreamForm />
    </div>
    
</template>
    
<script>
import WebRtcLivestreamForm from '@/components/webrtc/WebRtcLivestreamForm.vue';

export default {
    components: {
        WebRtcLivestreamForm,
    },
}
</script>

<style lang="scss" scoped></style>